const tabsConstants = {
  REGISTER_NEW_TABS_COMPONENT: 'REGISTER_NEW_TABS_COMPONENT',
  CHANGE_TAB:                  'CHANGE_TAB',
};

export default tabsConstants;